import styled, { keyframes } from "styled-components";
import bgSrc from "assets/images/BG.png";
import { Flex } from "Element/Flex";

export const StyledLanding = styled.div`
  margin: 32px 0 72px;
  margin-top: 112px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin-top: 178px;
  `}
`;

export const bgScroll = keyframes`
  0%{background-position: 0 0;}
	100%{background-position: 0 1304px;}
`;
export const BackgroundWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 652px;
  background-image: url(${bgSrc});
  background-color: ${({ theme }) => theme.colors.neutral20};
  background-repeat: repeat-y;
  background-size: cover;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  animation: ${bgScroll} 10s linear infinite;
  animation-delay: -1;
  animation-fill-mode: forwards;
  z-index: 1;
  /* animation-direction: alternate-reverse; */
  a {
    ${({ theme }) => theme.mediaWidth.upToSmall`
      width: 100%;
  `}
  }
`;

export const StyledHeroText = styled.h1<{
  textAlign?: "left" | "center" | "right" | "justify";
  mt?: number;
}>`
  ${({ theme }) => theme.fontStyle.display}
  ${({ theme }) => theme.mediaWidth.upToMedium`
    font-size: 46px;
  `}
  margin-top:${({ mt }) => (!mt ? "80px" : mt + "px")};
  text-align: ${({ textAlign }) => (!textAlign ? "center" : textAlign)};
  position: relative;
  z-index: 1;
`;

export const DogeImgContainer = styled(Flex)`
  height: 100%;
  flex-wrap: nowrap;
`;
export const DogeImgWrapper = styled.div`
  height: 260px;
  width: 260px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
        height: 120px;
        width: 120px;
    `}
  &:nth-child(1) {
    ${({ theme }) => theme.mediaWidth.upToMedium`
      display: none;
    `}
  }
  &:nth-child(2) {
    margin-left: -75px;
    ${({ theme }) => theme.mediaWidth.upToMedium`
      margin-left: 0;
    `}
  }
  &:nth-child(3) {
    margin-left: -75px;
    z-index: 1;
    ${({ theme }) => theme.mediaWidth.upToSmall`
        margin-left: -35px;
    `}
  }
  &:nth-child(4) {
    margin-left: -75px;
    z-index: 0;
    ${({ theme }) => theme.mediaWidth.upToSmall`
        margin-left: -35px;
    `}
  }
  &:nth-child(5) {
    margin-left: -75px;
    z-index: 1;
    ${({ theme }) => theme.mediaWidth.upToSmall`
        margin-left: -35px;
    `}
  }
  &:nth-child(6) {
    margin-left: -75px;
    z-index: 1;
    ${({ theme }) => theme.mediaWidth.upToMedium`
      display: none;
    `}
  }
`;
export const DogeImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const GoDownButton = styled.button<{ small?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border: none;
  background-color: ${({ theme }) => theme.colors.neutral20};
  border-radius: 8px;
  height: fit-content;
  :first-child {
    margin-right: 80px;
  }
  :last-child {
    margin-left: 80px;
  }
  svg {
    width: ${({ small }) => (small ? 24 : 40)}px;
    height: ${({ small }) => (small ? 24 : 40)}px;
  }
`;

export const VerifiedSmartContract = styled(Flex)`
  a {
    color: ${({ theme }) => theme.colors.secondary40};
    :hover {
      text-decoration: underline;
    }
  }
`;
